module.exports = __webpack_public_path__ + "static/media/sv5.d348c57c.jpg";